import { useCallback, useState } from 'react'

import useCallbackRef from 'app/common/hooks/useCallbackRef'
import usePopup from 'app/common/hooks/usePopup'
import { useAdditionalSettingsMutate } from 'app/dataProviders/dishes/DishesData/additionalSettings/hooks'


type Options = {
  orgId: string
  dishId: number | null
  onSubmitSuccess?: () => void,
}

export default function useSubmit({ orgId, dishId, onSubmitSuccess }: Options): [
  boolean,
  (form: HTMLFormElement) => Promise<boolean>
] {
  const popup = usePopup()

  const [submitting, setSubmitting] = useState(false)
  const { submit: submitAdditionalSettings } = useAdditionalSettingsMutate({ orgId, dishId })
  const submitAdditionalSettingsRef = useCallbackRef(submitAdditionalSettings)
  const onSubmitSuccessRef = useCallbackRef(onSubmitSuccess)

  const submit = useCallback(async (form: HTMLFormElement) => {
    const formData = new FormData(form)
    setSubmitting(true)
    const disableForTerminalGuestSales = !!formData.get('disableForTerminalGuestSales')

    const res = await submitAdditionalSettingsRef.current?.({
      disableForTerminalGuestSales,
    })
    setSubmitting(false)

    if (res) {
      popup('Дополнительные настройки успешно применены')
      if (!onSubmitSuccessRef.current) {
        return true
      }
      onSubmitSuccessRef.current()
    }

    return !!res
  }, [submitAdditionalSettingsRef, popup, onSubmitSuccessRef])

  return [submitting, submit]
}
